/** 分页查询参数的最小约束 */
export interface PaginatedQuery {
    page: number;
    limit: number;
}

/** 列表默认每页条数（无特殊指定时统一 20） */
export const DEFAULT_PAGE_SIZE = 20;

/** 分页组件默认可选条数 */
export const DEFAULT_PAGE_SIZES = [20, 50, 100, 200] as const;

/** 报表等大数据列表默认每页条数 */
export const REPORT_PAGE_SIZE = 50;

/** 报表分页可选条数（最少 50） */
export const REPORT_PAGE_SIZES = [50, 100, 200] as const;

/** 列表接口统一返回结构 */
export interface ListResult<T> {
    list: T[];
    total: number;
}

/** 列表 fetchApi 可选参数（usePaginatedList 传入 signal 用于取消上一次请求） */
export interface FetchListOptions {
    signal?: AbortSignal;
}

export interface UsePaginatedListOptions<T, Q extends PaginatedQuery> {
    /** 页面持有的 reactive 查询对象 */
    queryParam: Q;
    /** 数据请求函数，mock 或 http 均由调用方注入；须透传 options.signal 到 http */
    fetchApi: (params: Q, options?: FetchListOptions) => Promise<ListResult<T>>;
    /** 进入页面是否自动请求，默认 true */
    immediate?: boolean;
    /** 请求失败时是否清空列表，默认 false */
    clearOnError?: boolean;
    /** 请求失败时是否弹出错误提示，默认 true */
    showErrorMessage?: boolean;
    /** 列表重新加载前回调（切换 Tab、分页、刷新等），用于清空表格勾选 */
    onListReload?: () => void;
    /**
     * 超过约 30 条时是否分批写入表格（先首屏再后台追加）。
     * 默认 true。广告列表等需要一次铺满、不接受分片补行时传 false。
     */
    progressive?: boolean;
}
